<template>
  <el-dialog :visible.sync="disableDialog" class="dialog-address" width="50%" :title="title">
    <el-row>
      <el-col :span="12" class="title">待分配产品</el-col>
      <el-col :span="12" style="text-align:right">
        <el-button @click="onAdd(2)" type="primary" plain>批量添加</el-button>
      </el-col>
    </el-row>
    <el-table
      style="margin:14px 0 30px"
      height="216px"
      ref="tableRefs"
      :data="list"
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column fixed type="selection" width="35"></el-table-column>
      <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
      <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
      <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="proType" label="型号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cbExtimeValue" label="货期">
        <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
      </el-table-column>
      <el-table-column prop="cbNumber" label="数量"></el-table-column>
      <el-table-column label="操作" fixed="right" width="85">
        <template slot-scope="scope">
          <el-button type="text" :disabled="!scope.row.isChecked" @click="onAdd(1,scope.row)">添加</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="12" class="title">本期产品</el-col>
      <el-col :span="12" style="text-align:right">
        <el-button @click="onDelete(2)" type="primary" plain>批量移除</el-button>
      </el-col>
    </el-row>
    <el-table
      style="margin-top:14px"
      height="216px"
      ref="custromTableRef"
      :data="listDelete"
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      @selection-change="handleSelectionChangeDelete"
      border
    >
      <el-table-column fixed type="selection" width="35"></el-table-column>
      <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
      <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
      <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="proType" label="型号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cbExtimeValue" label="货期">
        <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
      </el-table-column>
      <el-table-column label="数量" width="125">
        <template slot-scope="scope">
          <el-input-number
            style="width:100%"
            v-model="scope.row.cbNumber"
            controls-position="right"
            :min="1"
            :max="scope.row.max"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="85">
        <template slot-scope="scope">
          <span class="operation-font-color" @click="onDelete(1,scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-right">
      <el-button @click="onSubmit" type="primary">提交</el-button>
      <el-button @click="disableDialog=false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ['title'],
  data() {
    return {
      disableDialog: false,
      list: [],
      listDelete: [],
      total: 0,
      checkList: [],
      checkListDelete: [],
      productEditList: [],
      paramsIndex: -1
    }
  },
  methods: {
    // 设置期货初始化
    onInitial(val, arr, index) {
      val.forEach((ele) => {
        this.$set(ele, 'isChecked', true)
      })
      this.checkList = []
      this.checkListDelete = []
      this.disableDialog = true
      this.list = val || []
      if (arr) {
        this.listDelete = JSON.parse(JSON.stringify(arr))
        this.listDelete.forEach((item) => {
          this.list.forEach((ele) => {
            if (ele.id === item.id) {
              ele.isChecked = false
            }
          })
        })
        this.paramsIndex = index
      } else {
        this.listDelete = []
        this.paramsIndex = -1
      }
    },
    // 待分配产品
    handleSelectionChange(row) {
      this.checkList = row
    },
    // 协议价系列列表数据移除选中
    handleSelectionChangeDelete(row) {
      this.checkListDelete = row
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 添加
    onAdd(type, row) {
      if (type === 1) {
        // this.getAddData(row)
        this.list.forEach((res) => {
          if (row.id === res.id) {
            if (res.isChecked) {
              this.listDelete.push(JSON.parse(JSON.stringify(row)))
              res.isChecked = false
            }
          }
        })
      } else {
        if (this.checkList.length > 0) {
          this.checkList.forEach((item) => {
            this.getAddData(item)
          })
        } else {
          this.$message.error('请选择数据!')
        }
      }
    },
    getAddData(val) {
      // 添加后置灰选中过的数据
      this.list.forEach((res) => {
        if (val.id === res.id) {
          if (res.isChecked) {
            this.listDelete.push(JSON.parse(JSON.stringify(val)))
            res.isChecked = false
          }
        }
      })
      this.$refs.tableRefs.clearSelection()
    },
    // 本期产品移除
    onDelete(type, row) {
      if (type === 1) {
        this.getDeleteData(row)
        const index = this.listDelete.indexOf(row)
        this.listDelete.splice(index, 1)
      } else {
        // 选中后的数据
        if (this.checkListDelete.length > 0) {
          this.checkListDelete.forEach((item) => {
            const index = this.listDelete.indexOf(item)
            this.listDelete.splice(index, 1)
            this.getDeleteData(item)
          })
        } else {
          this.$message.error('请选择数据!')
        }
      }
    },
    // 移除协议价系列区数据的方法
    getDeleteData(item) {
      this.list.forEach((res) => {
        if (item.id === res.id) {
          res.isChecked = true
        }
      })
    },
    // 提交
    onSubmit() {
      if (this.listDelete.length > 0) {
        this.listDelete.forEach((ele) => {
          ele.isBool = false
          ele.cbTotal = ele.cbNumber * ele.cbPrice
          ele.cbUnitTotal = ele.cbNumber * ele.cbUnitPrice
        })
        const paramsJson = {
          // 设置期货
          orderShipmentQueryVoList: this.listDelete
        }
        if (this.paramsIndex !== -1) {
          paramsJson.paramsIndex = this.paramsIndex
        }
        this.$emit('addProductList', paramsJson)
        this.disableDialog = false
        this.$message.success('分配成功！')
      } else {
        this.$message.error('请选择本期产品')
      }
    },
    // 复选框是否可选
    selecTable(row, index) {
      if (row.isChecked) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: 500;
  color: #4e555b;
  line-height: 24px;
}
</style>
